let customizePayType1 = null;
let customizePayType2 = null;
if (window.localStorage["payType1"])
  customizePayType1 = JSON.parse(window.localStorage["payType1"]);
if (window.localStorage["payType2"])
  customizePayType2 = JSON.parse(window.localStorage["payType2"]);

export function getAll() {
  return [
    {
      value: 0,
      name: "Cash",
      text: "現金",
    },
    {
      value: 1,
      name: "CreditCard",
      text: "信用卡",
    },
    {
      value: 2,
      name: "EasyCard",
      text: "悠遊卡",
    },
    {
      value: 3,
      name: "Coupon",
      text: "折價券",
    },
    {
      value: 4,
      name: "PayType1",
      text: customizePayType1 ? customizePayType1 : "結帳別1",
    },
    {
      value: 5,
      name: "PayType2",
      text: customizePayType2 ? customizePayType2 : "結帳別2",
    },
    {
      value: 6,
      name: "Receivable",
      text: "應收帳款",
    },
    {
      value: 8,
      name: "Deposit",
      text: "儲值金",
    },
    {
      value: 9,
      name: "LinePay",
      text: "LINE Pay",
    },
    {
      value: 10,
      name: "CouponForStock",
      text: "折價券(條碼)",
    },
    {
      value: 11,
      name: "iPASS",
      text: "一卡通",
    },
    {
      value: 12,
      name: "PXPay",
      text: "全支付",
    },
    {
      value: 13,
      name: "Scan2Pay",
      text: "Scan2Pay",
    },
    {
      value: 14,
      name: "PGTalk",
      text: "PGTalk",
    },
    {
      value: 15,
      name: "JKOPay",
      text: "街口支付",
    },
  ];
}

export function getForProductType(productType) {
  switch (productType) {
    case 0:
      return [
        {
          value: 0,
          name: "Cash",
          text: "現金",
        },
        {
          value: 1,
          name: "CreditCard",
          text: "信用卡",
        },
        {
          value: 2,
          name: "EasyCard",
          text: "悠遊卡",
        },
        {
          value: 3,
          name: "Coupon",
          text: "折價券",
        },
        {
          value: 4,
          name: "PayType1",
          text: customizePayType1 ? customizePayType1 : "結帳別1",
        },
        {
          value: 5,
          name: "PayType2",
          text: customizePayType2 ? customizePayType2 : "結帳別2",
        },
        {
          value: 6,
          name: "Receivable",
          text: "應收帳款",
        },
        {
          value: 8,
          name: "Deposit",
          text: "儲值金",
        },
        {
          value: 9,
          name: "LinePay",
          text: "LINE Pay",
        },
        {
          value: 10,
          name: "CouponForStock",
          text: "折價券(條碼)",
        },
        {
          value: 11,
          name: "iPASS",
          text: "一卡通",
        },
        {
          value: 12,
          name: "PXPay",
          text: "全支付",
        },
        {
          value: 13,
          name: "Scan2Pay",
          text: "Scan2Pay",
        },
        {
          value: 14,
          name: "PGTalk",
          text: "PGTalk",
        },
        {
          value: 15,
          name: "JKOPay",
          text: "街口支付",
        },
      ];
    case 2:
      return [
        {
          value: 0,
          name: "Cash",
          text: "現金",
        },
        {
          value: 1,
          name: "CreditCard",
          text: "信用卡",
        },
        {
          value: 3,
          name: "Coupon",
          text: "折價券",
        },
        {
          value: 4,
          name: "PayType1",
          text: customizePayType1 ? customizePayType1 : "結帳別1",
        },
        {
          value: 5,
          name: "PayType2",
          text: customizePayType2 ? customizePayType2 : "結帳別2",
        },
        {
          value: 6,
          name: "Receivable",
          text: "應收帳款",
        },
        {
          value: 8,
          name: "Deposit",
          text: "儲值金",
        },
        {
          value: 9,
          name: "LinePay",
          text: "LINE Pay",
        },
        {
          value: 12,
          name: "PXPay",
          text: "全支付",
        },
        {
          value: 14,
          name: "PGTalk",
          text: "PGTalk",
        },
      ];
    case 3:
      return [
        {
          value: 0,
          name: "Cash",
          text: "現金",
        },
        {
          value: 1,
          name: "CreditCard",
          text: "信用卡",
        },
        {
          value: 4,
          name: "PayType1",
          text: customizePayType1 ? customizePayType1 : "結帳別1",
        },
        {
          value: 5,
          name: "PayType2",
          text: customizePayType2 ? customizePayType2 : "結帳別2",
        },
        {
          value: 6,
          name: "Receivable",
          text: "應收帳款",
        },
      ];
    case 4:
      return [
        {
          value: 0,
          name: "Cash",
          text: "現金",
        },
        {
          value: 1,
          name: "CreditCard",
          text: "信用卡",
        },
        {
          value: 4,
          name: "PayType1",
          text: customizePayType1 ? customizePayType1 : "結帳別1",
        },
        {
          value: 5,
          name: "PayType2",
          text: customizePayType2 ? customizePayType2 : "結帳別2",
        },
        {
          value: 6,
          name: "Receivable",
          text: "應收帳款",
        },
        {
          value: 9,
          name: "LinePay",
          text: "LINE Pay",
        },
        {
          value: 12,
          name: "PXPay",
          text: "全支付",
        },
        {
          value: 14,
          name: "PGTalk",
          text: "PGTalk",
        },
        {
          value: 15,
          name: "JKOPay",
          text: "街口支付",
        },
      ];
    default:
      return [];
  }
}

export function getForSale() {
  return [
    {
      value: 0,
      name: "Cash",
      text: "現金",
    },
    {
      value: 1,
      name: "CreditCard",
      text: "信用卡",
    },
    {
      value: 4,
      name: "PayType1",
      text: customizePayType1 ? customizePayType1 : "結帳別1",
    },
    {
      value: 5,
      name: "PayType2",
      text: customizePayType2 ? customizePayType2 : "結帳別2",
    },
    {
      value: 6,
      name: "Receivable",
      text: "應收帳款",
    },
  ];
}
export function getForAccount() {
  return [
    {
      value: 0,
      name: "Cash",
      text: "現金",
    },
    {
      value: 1,
      name: "CreditCard",
      text: "信用卡",
    },
    {
      value: 4,
      name: "PayType1",
      text: customizePayType1 ? customizePayType1 : "結帳別1",
    },
    {
      value: 5,
      name: "PayType2",
      text: customizePayType2 ? customizePayType2 : "結帳別2",
    },
  ];
}

export function getByName(name) {
  const type = getAll().find(function (item) {
    return item.name.toLowerCase() == name.toLowerCase();
  });
  return type;
}
